'use client';

import { useState } from 'react';
import Link from 'next/link';
import { HiChevronDown } from 'react-icons/hi';

import { Faq } from 'src/services/keystone-types';
import { DocumentRendererProps } from '@keystone-6/document-renderer';
import { ContentRenderer } from '@portal/content-renderer';

type Props = {
    faq: Faq;
};

const renderers: DocumentRendererProps['renderers'] = {
    block: {
        paragraph: ({ children }) => {
            return <p className="mb-4">{children}</p>;
        },
    },
    inline: {
        link: ({ href, children }) => (
            <Link href={href} className="text-third underline hover:no-underline">
                {children}
            </Link>
        ),
    },
};

export default function FaqCard({ faq }: Props) {
    const [collapsed, setCollapsed] = useState(true);

    return (
        <div className="relative mb-4 bg-white p-4 md:p-8">
            <HiChevronDown
                aria-hidden
                onClick={() => setCollapsed(!collapsed)}
                className={`absolute right-4 top-4 cursor-pointer text-2xl transition duration-200 ease-out md:top-8 ${
                    collapsed ? '' : ' rotate-180'
                }`}
            />
            <div className="cursor-pointer gap-4 md:flex" onClick={() => setCollapsed(!collapsed)}>
                <h2
                    className={`text-primary pr-4 text-lg decoration-1 underline-offset-4 hover:underline md:w-1/2 md:pr-0 md:text-xl${
                        collapsed ? '' : ' underline'
                    }`}>
                    {faq.name}
                </h2>
            </div>
            {!collapsed && (
                <>
                    <div className="mt-4">
                        <ContentRenderer content={faq.content} renderers={renderers} />
                    </div>
                </>
            )}
        </div>
    );
}
